/** @module Enums */ /** typedoc */
var ReleaseLanguagesEnum;
(function (ReleaseLanguagesEnum) {
    ReleaseLanguagesEnum["en"] = "en";
    ReleaseLanguagesEnum["fr"] = "fr";
    ReleaseLanguagesEnum["de"] = "de";
    ReleaseLanguagesEnum["ar"] = "ar";
    ReleaseLanguagesEnum["zh-yue"] = "zh-yue";
    ReleaseLanguagesEnum["ca"] = "ca";
    ReleaseLanguagesEnum["zh"] = "zh";
    ReleaseLanguagesEnum["zh-hant"] = "zh-hant";
    ReleaseLanguagesEnum["hr"] = "hr";
    ReleaseLanguagesEnum["cs"] = "cs";
    ReleaseLanguagesEnum["da"] = "da";
    ReleaseLanguagesEnum["nl"] = "nl";
    ReleaseLanguagesEnum["et"] = "et";
    ReleaseLanguagesEnum["fi"] = "fi";
    ReleaseLanguagesEnum["el"] = "el";
    ReleaseLanguagesEnum["he"] = "he";
    ReleaseLanguagesEnum["hi"] = "hi";
    ReleaseLanguagesEnum["hu"] = "hu";
    ReleaseLanguagesEnum["is"] = "is";
    ReleaseLanguagesEnum["id"] = "id";
    ReleaseLanguagesEnum["it"] = "it";
    ReleaseLanguagesEnum["ja"] = "ja";
    ReleaseLanguagesEnum["ko"] = "ko";
    ReleaseLanguagesEnum["lo"] = "lo";
    ReleaseLanguagesEnum["lv"] = "lv";
    ReleaseLanguagesEnum["lt"] = "lt";
    ReleaseLanguagesEnum["ms"] = "ms";
    ReleaseLanguagesEnum["no"] = "no";
    ReleaseLanguagesEnum["pl"] = "pl";
    ReleaseLanguagesEnum["pt"] = "pt";
    ReleaseLanguagesEnum["ro"] = "ro";
    ReleaseLanguagesEnum["ru"] = "ru";
    ReleaseLanguagesEnum["sk"] = "sk";
    ReleaseLanguagesEnum["es"] = "es";
    ReleaseLanguagesEnum["sv"] = "sv";
    ReleaseLanguagesEnum["tl"] = "tl";
    ReleaseLanguagesEnum["th"] = "th";
    ReleaseLanguagesEnum["tr"] = "tr";
    ReleaseLanguagesEnum["uk"] = "uk";
    ReleaseLanguagesEnum["vi"] = "vi";
})(ReleaseLanguagesEnum || (ReleaseLanguagesEnum = {}));

export { ReleaseLanguagesEnum };
